export const API_URL = process.env.ROLLUP_ENV_STRAPI_CMS_URL;
export const API_KEY = process.env.ROLLUP_ENV_STRAPI_CMS_API_KEY;
export const UPLOADS_DIRECTORY = process.env.ROLLUP_ENV_STRAPI_UPLOADS_DIRECTORY;